module.exports = "<div class=\"content\" *ngIf=\"contentActive\">\n    <ng-content></ng-content>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/common/components/wizard/wizard.content.template.html
// module id = 929
// module chunks = 0